import { BusinessStatus } from '@Store/slices/customer/customer.types.ts';
import type { KybData } from './kyb.types.ts';

export const getKybModel = (): KybData => {
  return {
    business: {
      externalId: '',
      name: '',
      naicsIndustry: '',
      businessType: '',
      status: BusinessStatus.NONE,
      missingLlcDocuments: [],
      primaryOwnershipPercent: 0,
    },
  };
};
